export const API_URL_DEV = 'https://api-dev.skipservice.org/';
export const AUTHENTICATED_PATH = 'v1/oauth2/token';
export const GET_USER_PROFILE_PATH = '/v1/user/profile';
export const LOGIN_URL =
  'https://auth-dev.skipservice.org/login?client_id=620pnf9sa20q1260dadqt6jah&response_type=code&scope=aws.cognito.signin.user.admin&redirect_uri=https://app-dev.skipservice.org/';
